export const createFacebookLoginFallback = ({
  onFallback,
  timeoutMs = 3000,
  win = window,
  doc = document,
}) => {
  let callbackHandled = false;
  let popupLikelyOpened = false;
  let timeoutId = null;

  const markPopupLikelyOpened = () => {
    popupLikelyOpened = true;
  };

  const handleBlur = () => {
    markPopupLikelyOpened();
  };

  const handleVisibilityChange = () => {
    if (doc.visibilityState === "hidden") {
      markPopupLikelyOpened();
    }
  };

  const cleanup = () => {
    if (timeoutId !== null) {
      win.clearTimeout(timeoutId);
      timeoutId = null;
    }

    win.removeEventListener?.("blur", handleBlur);
    doc.removeEventListener?.("visibilitychange", handleVisibilityChange);
  };

  const start = () => {
    win.addEventListener?.("blur", handleBlur);
    doc.addEventListener?.("visibilitychange", handleVisibilityChange);

    timeoutId = win.setTimeout(() => {
      const shouldFallback = !callbackHandled && !popupLikelyOpened;
      cleanup();

      if (shouldFallback) {
        onFallback?.();
      }
    }, timeoutMs);
  };

  const markCallbackHandled = () => {
    callbackHandled = true;
    cleanup();
  };

  return {
    start,
    cleanup,
    markCallbackHandled,
    wasPopupLikelyOpened: () => popupLikelyOpened,
  };
};
